import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getLessonImageUploadPresignedUrl(_obj, data) {
    const res = await axios.post(`api/lms/lessons/upload-url/`, data);
    return res.data;
  },
};

export const lessons = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
